import React from "react";
import { Link } from "react-router-dom";
import { company } from "../data/navigation";
type LogoProps = {
  onClick?: () => void;
};
export function Logo({
  onClick
}: LogoProps) {
  return <Link to="/" onClick={onClick} className="flex items-center gap-2.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" aria-label={`${company.name} — accueil`} data-id="element-194" data-mp="3qa352hi4wl4u">
      <svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true" data-id="element-195" data-mp="mtw4wkyxh60t">
        <rect width="34" height="34" rx="10" fill="#D4F36B" data-id="element-196" data-mp="rsh3yh2g1jno" />
        <path d="M17 7c-3.6 4.6-6.5 8.4-6.5 12a6.5 6.5 0 0 0 13 0c0-3.6-2.9-7.4-6.5-12Z" fill="#063B3F" data-id="element-197" data-mp="rpuw0gbn524x" />
        <path d="M14 20.5a3 3 0 0 0 3 3" stroke="#D4F36B" strokeWidth="1.8" strokeLinecap="round" fill="none" data-id="element-198" data-mp="hthwh1tezu29" />
      </svg>
      <span className="text-[22px] font-semibold tracking-tight text-white" data-id="element-199" data-mp="32k0gwchcbzbi">
        {company.name}
      </span>
    </Link>;
}